import * as React from "react"
import {TemplateRevision} from "./data";
import {FixedDataGrid, NodeData, Row} from "../../lib/sbhtml/fixed-data-grid";

type VersionHistoryProps = ValueProps & CallbackProps

type ValueProps = {
	templateVersions: TemplateRevision[]
	activeVersion: string
	viewingVersion: string
}

type CallbackProps = {
	editTemplate: () => void
	viewTemplate: (id: string) => void
}

const headings = {
	id: "#",
	title: 'Title',
	createdBy: 'Created By',
	createdDate: 'Created Date',
	onClick: ''
}

type VersionHistoryRow = typeof headings

const makeRow = (props: VersionHistoryProps) => (tr:TemplateRevision): Row<keyof VersionHistoryRow> => {
	const title = tr.isActiveVersion ? <span>{tr.title} <ActiveLabel/></span> : tr.title
	return {
		onClick: () => {
			const id = tr.id
			id === props.activeVersion ? props.editTemplate() : props.viewTemplate(id)
		},
		id: {node: tr.id, minWidth: '40px'},
		title: {node: title, alignment:"left"},
		createdBy: {node: tr.createdBy, alignment:"left"},
		createdDate: {node: tr.createdDate, alignment:"left"},
	}
}

const ActiveLabel = () => {
	// Ravi requested a button like this so I let him make it :lul:
	return <small
		style={{
			marginLeft: '8px',
			backgroundColor: '#00ab4e',
			backgroundClip: 'padding-box',
			border: '1px solid #00ab4e',
			whiteSpace: 'nowrap',
			padding: '2px 5px',
			borderRadius: '3px',
			fontWeight: 700,
			lineHeight: '1em',
			color: '#fff',
		}}
	>Active</small>
}

class VersionHistoryDataGrid extends FixedDataGrid<VersionHistoryRow> {}

export const VersionHistoryList = (props:VersionHistoryProps) => {
	const rows = props.templateVersions.map(makeRow(props))
	return <VersionHistoryDataGrid
		heading={headings}
		data={rows}
		highlight={(r: Row<keyof VersionHistoryRow>) => (r.id as NodeData).node === props.viewingVersion}
		rowClick='onClick'
	/>
}



// WEBPACK FOOTER //
// ./src/communications/version-history/presentation.tsx